if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButtons = this.querySelectorAll('[type="submit"]');
        this.submitButton = this.submitButtons[0];
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButtons.forEach(function(btn) {
            btn.setAttribute('aria-haspopup', 'dialog');
          });
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        // Detect which button was clicked
        var activeBtn = evt.submitter && evt.submitter.type === 'submit' ? evt.submitter : this.submitButton;
        var activeSpinner = activeBtn.querySelector('.loading__spinner');

        if (activeBtn.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        /* ── Seek Key: block duplicate items ── */
        const variantId = this.variantIdInput.value;
        try {
          const cartResp = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
          const cartData = await cartResp.json();
          const alreadyInCart = cartData.items.some(function(item) {
            return String(item.variant_id) === String(variantId);
          });
          if (alreadyInCart) {
            this.showDuplicateToast();
            return;
          }
        } catch (e) {
          /* If cart check fails, proceed normally */
        }
        /* ── End duplicate check ── */

        // Disable all submit buttons during request
        this.submitButtons.forEach(function(btn) {
          btn.setAttribute('aria-disabled', true);
        });
        activeBtn.classList.add('loading');
        if (activeSpinner) activeSpinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = activeBtn.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              activeBtn.setAttribute('aria-disabled', true);
              activeBtn.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            activeBtn.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) {
              this.submitButtons.forEach(function(btn) {
                btn.removeAttribute('aria-disabled');
              });
            }
            if (activeSpinner) activeSpinner.classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      showDuplicateToast() {
        var existing = document.querySelector('.sk-duplicate-toast');
        if (existing) existing.remove();

        var toast = document.createElement('div');
        toast.className = 'sk-duplicate-toast';
        toast.textContent = 'Este jogo já está no seu carrinho';
        document.body.appendChild(toast);

        setTimeout(function() {
          if (toast.parentNode) toast.remove();
        }, 3200);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        // Store original texts on first call so we can restore them
        if (!this._originalTexts) {
          this._originalTexts = new Map();
          this.submitButtons.forEach(function(btn) {
            var span = btn.querySelector('span');
            if (span) this._originalTexts.set(btn, span.textContent);
          }.bind(this));
        }

        if (disable) {
          this.submitButtons.forEach(function(btn) {
            btn.setAttribute('disabled', 'disabled');
            if (text) {
              var span = btn.querySelector('span');
              if (span) span.textContent = text;
            }
          });
        } else {
          this.submitButtons.forEach(function(btn) {
            btn.removeAttribute('disabled');
            var span = btn.querySelector('span');
            if (span) {
              var original = this._originalTexts.get(btn);
              span.textContent = original || window.variantStrings.addToCart;
            }
          }.bind(this));
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
